module.exports = __webpack_public_path__ + "img/t2-c26.84fcebc2.png";